// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__392UL","col":"styles_col__DjJom"};